export const setSTAKEHOLDERSOBJECT = "setSTAKEHOLDERSOBJECT";
